import { createSaga } from './saga-helpers';

import * as Api from '../api/checklist-api';

const watchCreateChecklist = createSaga({
    type: 'CHECKLIST_CREATE',
    fn: Api.createChecklist,
    args: action => [action.payload.taskId, action.payload.checklist],
    successPayload: ({ id: checklistId }, action) => ({
        checklistId,
        fragment: action.payload.checklist
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.checklist
    })
});

const watchGetChecklist = createSaga({
    type: 'CHECKLIST_FETCH',
    fn: Api.fetchChecklist,
    args: action => [action.payload.checklistId],
    successPayload: checklist => ({ checklist })
});

const watchUpdateChecklist = createSaga({
    type: 'CHECKLIST_UPDATE',
    fn: Api.updateChecklist,
    args: action => [action.payload.checklistId, action.payload.checklistProps],
    successPayload: checklist => ({ checklist })
});

const watchRemoveChecklist = createSaga({
    type: 'CHECKLIST_REMOVE',
    fn: Api.removeChecklist,
    args: action => [action.payload.checklistId]
});

const watchCreateChecklistItems = createSaga({
    type: 'CHECKLIST_ITEMS_CREATE',
    fn: Api.createChecklistItems,
    args: action => [action.payload.checklistId, action.payload.checklistItems],
    successPayload: (checklistItems, action) => ({
        checklistItems,
        checklistId: action.payload.checklistId
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        checklistId: action.payload.checklistId
    })
});

const watchUpdateChecklistItem = createSaga({
    type: 'CHECKLIST_ITEM_UPDATE',
    fn: Api.updateChecklistItem,
    args: action => [action.payload.checklistId, action.payload.checklistItemId, action.payload.checklistItemProps],
    successPayload: checklistItem => ({ checklistItem })
});

const watchRemoveChecklistItem = createSaga({
    type: 'CHECKLIST_ITEM_REMOVE',
    fn: Api.removeChecklistItem,
    args: action => [action.payload.checklistId, action.payload.checklistItemId]
});

const sagas = [watchCreateChecklist, watchGetChecklist, watchUpdateChecklist, watchRemoveChecklist, watchCreateChecklistItems, watchUpdateChecklistItem, watchRemoveChecklistItem];

export default sagas;
